import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import {
  fetchTenantDetailsStart,
  getAdminRoleStart,
  getTenantAdminRoleStart,
  getTenantRoleStart
} from '../../store/redux-slices/login'
import {
  getSuperAdminDetailsStart
} from '../../store/redux-slices/admins'
import { getLoginToken, isTokenExpired } from '../../utils/storageUtils'
import { AdminsRoutes } from '../../routes'

const usePrivateRoute = (isTenantRoute) => {
  const accessToken = getLoginToken()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { loading } = useSelector((state) => state.login)

  useEffect(() => {
    if (accessToken && !isTokenExpired()) {
      dispatch(getAdminRoleStart())
      dispatch(getTenantRoleStart())
      dispatch(getSuperAdminDetailsStart({ isTenant: false, onStart: true }))
    } else {
      localStorage.clear();
      navigate(AdminsRoutes.SuperAdminSignin)
    }
  }, [accessToken, isTenantRoute])

  return {
    accessToken,
    loading
  }
}

export default usePrivateRoute
